import React, { useEffect, useState, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { getAxiosResponse } from '../../services/authApiRoutes/APImethods'
import {dateConvertToTimeStamp, TIME_LIST,} from '../../services/Util'
import APIUrls from '../../services/APIUrls'
import Select from 'react-select';
import DatePickerCalendar from '../dashboard/calendars/DatePickerCalendar'
import { useSelector, useDispatch } from 'react-redux'
import { updateProjectInfo } from '../../redux/reducers/ProjectInfoSlice'
import { updateProjectInfoValidation } from '../../redux/reducers/ProjectInfoValidationSlice'
import Constants from '../../Constants'
import { useTranslation } from 'react-i18next'
import ReactTooltip from 'react-tooltip';
import $ from "jquery";
import { calenderIcon } from '../../AppIcons'
import dateUtil from "../../services/DateUtil";
import DateFormat from "../../pages/DateFormat";

export const InternalVendor = ({ setProjectData }) => {
	const { t } = useTranslation();
	const translate = t;
	const params = useParams()
	const [minDate, setMinDate] = useState();
	const [internalTranslator, setInternalTranslator] = useState([])
	const [customerPurchaseOrder, setCustomerPurchaseOrder] = useState([])
	const [toggleIntialCal, toggleIntialCalFlag] = useState(false);
	const refToggle2 = useRef(null);
	const refCalendar2 = useRef(null);
	const [customerPurchaseOrderData, setCustomerPurchaseOrderData] = useState([])
	const [deliveryDueTime,setDeliveryDueTime]=useState(-1)

	const dispatch = new useDispatch();

	const projectData = useSelector(
		(reduxStore) => reduxStore.project_info
	).value;

	const sourceLanguageRedux = useSelector(
		(reduxStore) => reduxStore.source_language_for_project_creation
	).value;

	const targetLanguagesRedux = useSelector(
		(reduxStore) => reduxStore.target_language_for_project_creation
	).value;

	const custBootstrapDataRedux = useSelector((reduxStore) => reduxStore.customer_bootstrap_data).value;
	const userTimeZone = custBootstrapDataRedux?.user?.timeZone;
	const dispatchFinalDataToRedux = (type, value) => {
		dispatch(updateProjectInfo({
			type: type,
			value: value
		}));
	}
	const errorData = useSelector(
		(reduxStore) => reduxStore.project_info_validation_slice
	).value;

	const setProjectInfoValidationToRedux = (type, value) => {
		dispatch(updateProjectInfoValidation({
			type: type,
			value: value
		}));
	}

	const setTime = (event) =>{
		if(projectData?.deliveryDueDate) {
			let currentDeliveryDueDate = dateUtil.convertToServerMoment(projectData.deliveryDueDate);
			currentDeliveryDueDate.set({
				'hour': parseInt(event.value),
				'minute': 0,
				'second': 0,
				'millisecond': 0,
			})
			setDeliveryDueTime(event.value);
			dispatchFinalDataToRedux('deliveryDueDate', dateUtil.timestampObj(currentDeliveryDueDate, true));
		}
	  }
	useEffect(() => {
		if (internalTranslator && internalTranslator.length > 0) {
			getInternalRequest();
		}
	}, [internalTranslator])

	const setNote = (event) => {
		dispatchFinalDataToRedux('notes', event.target.value)
	}

	const setCustomerPO = (event) => {
		if(event !==null){
		  const po = customerPurchaseOrderData.filter(data => data.id == event.value)
		  dispatchFinalDataToRedux('purchaseOrder', po[0])
		}else{
		  dispatchFinalDataToRedux('purchaseOrder', null)
		}
		setProjectInfoValidationToRedux('purchaseOrder', Constants.BLANK);
	  }
	useEffect(data => {
		getInternalTranslatorVendor(projectData.userGroup.id)
		getAllCustomerPurchaseOrder()
		setMinDate(new Date().toISOString().slice(0, 10))
		dispatchFinalDataToRedux(
			'status', 'CONFIGURED_BID_OPTIONS'
		)
		dispatchFinalDataToRedux('assignment', null)
		if(projectData.deliveryDueDate){
			setDeliveryDueTime(dateUtil.convertToServerMoment(projectData?.deliveryDueDate).hour())
		  }
		  dispatchFinalDataToRedux('projectVendorType', 'INTERNAL' );
		  setProjectInfoValidationToRedux('deliveryDueDate', Constants.BLANK);
		  setProjectInfoValidationToRedux('purchaseOrder', Constants.BLANK);
	}, [])

	const assigneeUser = (index, data) => {
		internalTranslator.forEach((obj, id) => {
			if (index === id) {
				obj.checked = true;

				dispatchFinalDataToRedux(
					'assignment', {
					assigneeUser: { userId: data.userId, firstName: data.firstName, lastName: data.lastName }, status: null, id: -1
				}
				)
			}
			else {
				obj.checked = false;
			}
		})

		setProjectInfoValidationToRedux('internalTranslators', false)
	}

	const internalVendorSelectionOnKeyDown = (event, index, res) => {
		if(event.key === Constants.ENTER) {
			assigneeUser(index, res);
		}
	}

	const setDeliveryDueDate = (event) => {
		let newDeliveryDueDate = dateUtil.convertToServerMoment(event).set({
            'hour': deliveryDueTime === -1? 0 : deliveryDueTime,
            'minute': 0,
            'second': 0,
            'millisecond': 0,
        });
        let isDateGreaterThanWorkspaceDueDate = projectData?.workspace !== null ? newDeliveryDueDate.isAfter(dateUtil.convertToServerMoment(projectData?.workspace?.dueDate)) : false;
		if(isDateGreaterThanWorkspaceDueDate) {
			dispatchFinalDataToRedux('deliveryDueDateExceeded', true);
			setProjectInfoValidationToRedux('deliveryDueDate',  `The selected translation deadline is after the project campaign's due date of ${dateUtil.format(projectData?.workspace?.dueDate)}. If this is incorrect, please select a different date.`);
		} else {
			dispatchFinalDataToRedux('deliveryDueDateExceeded', false);
			setProjectInfoValidationToRedux('deliveryDueDate', Constants.BLANK);
		}
		dispatchFinalDataToRedux('deliveryDueDate', dateUtil.timestampObj(newDeliveryDueDate, true))
		setProjectInfoValidationToRedux('projectDueDateInternalTranslator', false)
		$('#cal-secondFocus').trigger('focus');
	   toggleIntialCalFlag(false);
	}

	const getInternalTranslatorVendor = async (depId) => {
		const dateTimestamp = dateConvertToTimeStamp();
		const result = await getAxiosResponse(APIUrls.INTERNAL_TRANSALATOR(depId) + `?_=${dateTimestamp}`)
		if(result?.data?.data){
			setInternalTranslator(result.data.data)
		}
	}

	const getInternalRequest = async () => {
		const dateTimestamp = dateConvertToTimeStamp();
		const result = await getAxiosResponse(APIUrls.INTERNAL_REQUEST(params.id) + `?_=${dateTimestamp}`)

		if (result?.data?.data?.assigneeUser && internalTranslator) {
			internalTranslator.forEach(ven => {
				if (ven.userId === result?.data?.data?.assigneeUser.userId) {
					ven.checked = true;
					dispatchFinalDataToRedux(
						'assignment', {
						assigneeUser: { userId: result?.data?.data?.assigneeUser.userId, firstName: result?.data?.data?.assigneeUser.firstName, lastName: result?.data?.data?.assigneeUser.lastName }, status: null, id: -1
					}
					)
				}
				else {
					ven.checked = false;
				}
			})
		}
	}



	const getAllCustomerPurchaseOrder = async () => {
		const dateTimestamp = dateConvertToTimeStamp();
		const result = await getAxiosResponse(APIUrls.CUSTOMER_PURCHASE_ORDER + `?_=${dateTimestamp}`)
		setCustomerPurchaseOrderData(result?.data?.data)
		if(result?.data?.data && result?.data?.data.length > 0){
		const purchaseOrderData = result?.data?.data.map(({ shortDisplay, id }) => ({
			value: id,
			label: shortDisplay
		}))
		setCustomerPurchaseOrder(purchaseOrderData)
	}
	}

	const setPo = (event) => {
		if(customerPurchaseOrder && customerPurchaseOrder.length > 0 ){
			customerPurchaseOrder.map(data => {
				if (data.id == event.target.value) {
					setProjectData('purchaseOrder', data)
				}
			})
		}
		
	}

	const showCalendarDiliveryDate = () => {
		toggleIntialCal ? toggleIntialCalFlag(false) : toggleIntialCalFlag(true);
		$('#cal-secondFocus').toggleClass('cal-secondFocus');
		if (toggleIntialCal) {
			var requiredElement = document.querySelector(".dashCalendar2");
			if(requiredElement !== null) {
				requiredElement.focus();
			}
		}
	};
	$(".cal-secondFocus").on("keydown", function (e) {
		if (e.key === Constants.ESCAPE) {
			if($('div').hasClass('dashCalendarInternal')){
			setTimeout(() => {
				toggleIntialCalFlag(false);
				$('.cal-secondFocus').trigger('focus')
				$('.cal-secondFocus').removeClass('cal-secondFocus')
			}, 100);
			}
		}
		if (e.key === Constants.TAB && e.shiftKey) {
			if($('div').hasClass('dashCalendarInternal')){
				toggleIntialCalFlag(false);
				$('.cal-secondFocus').trigger('focus')
				$('.cal-secondFocus').removeClass('cal-secondFocus')
			}
		}
	});
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				refCalendar2.current &&
				!refCalendar2.current.contains(event.target) &&
				!refToggle2.current.contains(event.target)
			) {
				toggleIntialCalFlag(false);
			}
		};

		document.addEventListener("click", handleClickOutside, true);
		return () => {
			document.removeEventListener("click", handleClickOutside, true);
		};
	}, [refCalendar2]);
	const closeCalendar = (e) => {
		if (e.code === "Escape") {
			toggleIntialCalFlag(false);
			$('.cal-secondFocus').trigger('focus');
			$('#cal-secondFocus').removeClass('cal-secondFocus');
		}
	};
	useEffect(()=>{
		$.each($('.react-calendar__tile'), function( index, value ) {
		  $(value).attr('aria-label', value.children[0].ariaLabel);
		});
	});
	const [refs, setRefs] = useState({});
	const translationTooltipRef = useRef(null);
	$('.tooltip-container p').on('keydown', function(e){
	  if(e.key === Constants.ESCAPE){
		if ($(this).attr('id') === "translationTooltip") {
		  setRefs(translationTooltipRef);
		}
	  }
	});
	useEffect(()=>{
		if (refs.current) {
		   refs.current.hideTooltip();
		   setRefs({});
		 }
	 }, [refs]);
	return (
		<div className="translate-project translate-vender">
			<div className="project-heading">
				<h3>{translate("other_integrations_project_creation.project_languages")}</h3>
			</div>
			<div className="vendor-content">
				<div className="project-language-block">
					<p><span>{sourceLanguageRedux.label || sourceLanguageRedux.display} to {targetLanguagesRedux.map((targetLanguage, index) => (targetLanguage.label || targetLanguage.display) + (index !== targetLanguagesRedux.length-1 ? ", " : ""))}
					</span></p>
				</div>
				<h5 id='internal-radioGroup'>{translate("other_integrations_project_creation.internal_translators")}</h5>
			    <div className="translate-box flex" role="radiogroup" aria-labelledby="internal-radioGroup">
				  {internalTranslator && internalTranslator.length   > 0 &&
						internalTranslator.map((res, index) => (
							<div key={index} className="translate-box-list">
								<a tabIndex="0"
								 role="radio"
								 aria-checked={res.checked ? ' true' : 'false'}
								 onClick={() => assigneeUser(index, res)}
								 onKeyDown={(e) => internalVendorSelectionOnKeyDown(e, index, res)}
								 className={res.checked ? ' vendor' : ''}>
									<span>{res.firstName} {res.lastName}</span>
								</a>
							</div>
						))
					}
				</div>
				{errorData.internalTranslators && <p className="textDanger"> Internal translators is required field </p>}
				<div className="vender-form-block">
					<h5>{translate("other_integrations_project_creation.translator_deadline")}</h5>
					<div className="flex wrap-dropdown wrap-group-dropdown">
						<div className="global-dropdown-block flex-center">
						<div className="tooltip-container">
                  <h6>{translate("other_integrations_project_creation.initial_translation")}</h6>
                  <p
                    tabIndex={0} data-events={['focus']} data-eventsoff={['blur']}
                    data-padding="10px 10px 10px 10px"
                    data-place="right"
                    data-tip={Constants.TRANSLATION_SUBMISSION_TOOLTIP}
                    data-for="translation-submission-tooltip"
					id='translationTooltip'
					aria-label='tooltip'
                  >
                    <svg
                      className="svg-tooltip-icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
                    </svg>
					<div className="font-zero">{Constants.TRANSLATION_SUBMISSION_TOOLTIP}</div>
                  </p>
                  <ReactTooltip
                    className="tooltip"
                    id="translation-submission-tooltip"
					role='tooltip'
					ref={translationTooltipRef}
                  ></ReactTooltip>
                </div>
							<div className="flex-center w-d100">
								<div className="global-dropdown-select lg-dropdown" >
								   <label htmlFor='cal-secondFocus' className='font-zero'>I need initial translation by</label>
									<button
										onClick={(e) => {
											showCalendarDiliveryDate(e);
										}}
										aria-expanded={toggleIntialCal ? 'true':'false'}
										aria-label={projectData?.deliveryDueDate ? `delivery due date ${dateUtil.format(projectData?.deliveryDueDate)} selected` : ''}
										ref={refToggle2}
										tabIndex={0}
										required
										id='cal-secondFocus'
									    type="button" className="drop-down-btn gb-dropBtn">
										<span>
                                            <DateFormat date={projectData?.deliveryDueDate}/>
                                        </span>
										<span className="font-zero">{projectData?.deliveryDueDate ? dateUtil.format(projectData?.deliveryDueDate) :"delivery due Date"}</span>
										{calenderIcon}
									</button>

								</div>
								{toggleIntialCal ? (<div ref={refCalendar2} onKeyDown={(e) => { closeCalendar(e); }}>
									<DatePickerCalendar 
										value={projectData?.deliveryDueDate ? new Date(dateUtil.convertToLocalDateTimestamp(projectData?.deliveryDueDate)) : ""}
										minDate={new Date()}
										className={"dashCalendarInternal"}
										selectDate={ setDeliveryDueDate}
									/>
								</div>) : (
									""
								)}
								<div className="global-dropdown-select small-dropdown-select">
									<Select className="" classNamePrefix='cw'
									 value={TIME_LIST.filter(function (option) {
										return option?.value === deliveryDueTime;
									  })}
									  aria-label="What Time?" onChange={event => setTime(event)} options={TIME_LIST} menuShouldScrollIntoView={false}
									/>
								</div>
							</div>
							{errorData.deliveryDueDate && <p className='textDanger'>{errorData.deliveryDueDate}</p>}
						</div>
					</div>
					<div className="flex wrap-dropdown">
						<div className="global-dropdown-block flex-center">
							<label>{translate("other_integrations_project_creation.po_number")} 
								<div className='tooltip-container optional-tooltip'>
									<p tabIndex={0} data-events={['focus']} data-eventsoff={['blur']}
									data-padding='10px 10px 10px 10px'
									id='purchaseOrderTooltip'
									aria-label='tooltip'
									data-place='bottom'
									data-tip={Constants.PURCHASE_ORDER_TOOLTIP}
									data-for='purchaseOrderTip'>
										<svg className="svg-tooltip-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
											<path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
										</svg>
										<div className="font-zero">{Constants.PURCHASE_ORDER_TOOLTIP}</div>
									</p>
									<ReactTooltip
									className='tooltip'
									id='purchaseOrderTip'
									role='tooltip'
									></ReactTooltip>
								</div>
								<span>Optional</span>
							</label>
							<div className="global-dropdown-select">
								<Select className="global-dropdown-select" classNamePrefix='cw'
								 value={customerPurchaseOrder.filter(function (option) {
									return option?.value === projectData?.purchaseOrder?.id;
								})} options={customerPurchaseOrder}
									aria-label="Purchase Order Number"
									onChange={e => setCustomerPO(e)}
									menuShouldScrollIntoView={false}
									isClearable={true}
								/>
							</div>
							{errorData.purchaseOrder && <p className='textDanger'>{errorData.purchaseOrder}</p>}
						</div>
					</div>

					<div className="flex wrap-dropdown textarea-group mar-bot10">
						<div className="global-dropdown-block flex-center mb-0">
							<label htmlFor='descriptions'>{translate("other_integrations_project_creation.notes_instruction_translator")} <span> {translate("project_listing.optional")}</span></label>
							<textarea maxLength="2500" id='descriptions' onChange={e => setNote(e)} value={projectData?.notes} className="textarea" placeholder="2500 characters limit"></textarea>
						</div>
					</div>
				</div>

			</div>
		</div>
	)
}
